// Importing React to build the component.
import React from 'react';

// Importing the CSS file for styling the header.
import '../FeedbackPage.css';

// FeedbackPageHeader component: Displays the title and description for the feedback page.
function FeedbackPageHeader() {
    return (
        <div className="feedback-page-header">
            <h1 className="text-center">We Value Your Feedback!</h1>
            <p className="text-center">Let us know what you think about your experience.</p>
        </div>
    );
}

// Exporting the FeedbackPageHeader component so it can be imported and used in other parts of the app.
export default FeedbackPageHeader;
